import { locationMasterActionTypes } from './../constants/ApiConstants';
const initialState = {
  master_data: null,
  loading: false,
  masterLocationsList: null,
  masterLocationDetails: null,
  saved_masterLocation: null,
  deleted_masterLocation: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case locationMasterActionTypes.get_masterdata.REQUEST:
    return {
      ...state,
      loading: true,
      master_data: null,
    };
  case locationMasterActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case locationMasterActionTypes.get_masterLocationsList.REQUEST:
    return {
      ...state,
      loading: true,
      masterLocationsList: null,
    };
  case locationMasterActionTypes.get_masterLocationsList.SUCCESS:
    return {
      ...state,
      loading: false,
      masterLocationsList: payload,
    };
  case locationMasterActionTypes.post_masterLocation.REQUEST:
    return {
      ...state,
      loading: true,
      saved_masterLocation: null,
    };
  case locationMasterActionTypes.post_masterLocation.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_masterLocation: payload,
    };
  case locationMasterActionTypes.get_masterLocationDetails.REQUEST:
    return {
      ...state,
      loading: true,
      masterLocationDetails: null,
    };
  case locationMasterActionTypes.get_masterLocationDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      masterLocationDetails: payload,
    };
  case locationMasterActionTypes.delete_masterLocation.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_masterLocation: null,
    };
    case locationMasterActionTypes.get_masterLocationDetailsReset.SUCCESS:
      return {
        ...state,
        masterLocationDetails: null
      };
  case locationMasterActionTypes.delete_masterLocation.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_masterLocation: payload,
    };
  default:
    return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/Masters/components/location-master/reducers/LocationMasterReducers.js